import starthubTheme from '../src/branding/starhubTheme.json';
import celcomTheme from '../src/branding/celcomTheme.json';
const domainCarriers = {
    // All starhub domains
    'http://localhost:3000': { 
        carrier: 'Starhub', 
        env: 'local',
        theme: starthubTheme
    },
    'https://co-starhub-oneops-sqa-blue.apac.nonprod-asurion53.com': { 
        carrier: 'Starhub', 
        env: 'qa',
        theme: starthubTheme
    },
    'https://sea-starhub-oneops-uat-blue.apac.asurion53.com': { 
        carrier: 'Starhub', 
        env: 'uat',
        theme: starthubTheme
    },
    'https://sea-starhub-oneops-prod-blue.apac.asurion53.com': { 
        carrier: 'Starhub', 
        env: 'prod',
        theme: starthubTheme
    },
    
    'https://ss-dpp.apac.asurion.com': { 
        carrier: 'Starhub', 
        env: 'prod',
        theme: starthubTheme
    },

    // All celcom domains
    'http://localhost:3001': { 
        carrier: 'Celcom', 
        env: 'local',
        theme: celcomTheme
    },
    'https://co-celcom-oneops-sqa-blue.apac.nonprod-asurion53.com': { 
        carrier: 'Celcom', 
        env: 'qa',
        theme: celcomTheme
    },
    'https://sea-celcom-oneops-uat-blue.apac.asurion53.com': { 
        carrier: 'Celcom', 
        env: 'uat',
        theme: celcomTheme
    },
    'https://sea-celcom-oneops-prod-blue.apac.asurion53.com': { 
        carrier: 'Celcom', 
        env: 'prod',
        theme: celcomTheme
    },
    'https://celcomdigi-dpp.apac.asurion.com': { 
        carrier: 'Celcom', 
        env: 'prod',
        theme: celcomTheme
    },
};


export const getCarrierByDomain = () => {
    return domainCarriers[window.location.origin]?.carrier || 'asurion';
};

export const getThemeByCarrier = () => {
    return domainCarriers[window.location.origin]?.theme || starthubTheme;
};

export const getEnvByDomain = () => {
    return domainCarriers[window.location.origin]?.env || 'dev';
};